import { render, staticRenderFns } from "./BargainComponent.vue?vue&type=template&id=7aefeb2f"
import script from "./BargainComponent.vue?vue&type=script&lang=js"
export * from "./BargainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports